// Valores dos selects incluem turma, dia e horário; não basta comparar só o ID.
export function turmaDisponivel(valor, opcoes, separador = '-') {
  return !!valor && opcoes.some(t => `${t.id}${separador}${t.dia ?? t.dia_semana}${separador}${t.horario}` === valor);
}
export const mensagemTurmaIndisponivel = 'Há uma turma indisponível para os filtros atuais. Selecione uma turma ativa antes de salvar.';
